import { useEffect, useState } from "react";
import { api } from "../lib/api";
import SeriesCard from "../components/SeriesCard";
import SkeletonRow from "../components/SkeletonRow";

export default function SeriesList() {
    const [series, setSeries] = useState([]);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        api.get("/series").then((r) => { setSeries(r.data); setLoading(false); });
    }, []);

    return (
        <div data-testid="series-list-page" className="pt-28 pb-16 mx-auto max-w-[1600px] px-6 lg:px-10">
            <div className="mb-10">
                <h1 className="font-display text-5xl sm:text-6xl font-black tracking-tight">Web Series</h1>
                <p className="text-white/60 mt-2">Cinematic AI-crafted stories. Binge the future.</p>
            </div>
            {loading ? (
                <SkeletonRow width="w-[260px]" aspect="aspect-[2/3]" count={6} />
            ) : (
                <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-6">
                    {series.map((s) => <SeriesCard key={s.id} series={s} />)}
                </div>
            )}
        </div>
    );
}
